/// <amd-module name="Wiki/Overview/Components/NavigationPane" />
import * as React from "react";
import { VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { css } from "VSSUI/Util";
import { WikiPage } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { WikiPageTree } from "Wiki/Overview/Components/WikiPageTree";
import { PagesHierarchyFetchedStatus, WikiTreeState } from "Wiki/Overview/Stores/WikiTreeStore";
import { WikiPageMenuItemsProvider } from "Wiki/Overview/WikiPageMenuItemsProvider";
import { WikiTreeDragDropProps } from "Wiki/PageTree/Components/WikiTree";
import { FilterTreeStore } from "Wiki/PageTree/Stores/FilterTreeStore";
import { WikiInfo } from "Wiki/ViewCommon/Contracts";
import { isCodeWiki } from "Wiki/ViewCommon/Utils/WikiHelper";

export interface INavigationPaneProps {
    wikiInfo: WikiInfo;
    showCreateNewProjectWikiAction: boolean;
    showPublishCodeWikiAction: boolean;
    isReorderInProgress: boolean;
    // tree
    onPageSelected: (newPage: WikiPage) => void;
    onPageToggled: (page: WikiPage, isExpanded: boolean) => void;
    treeState: WikiTreeState;
    filterStore: FilterTreeStore;
    onFilterChanged: (filterText: string) => void;
    onFilteringComplete: () => void;
    onFilteredPageSelected: (newPage: WikiPage) => void;
    selectedPagePath?: string;
    openInNewTab: (path: string) => void;

    menuItemProvider: WikiPageMenuItemsProvider;
    isHandleBrokenLinksEnabled: boolean;
    wikiTreeDragDropProps: WikiTreeDragDropProps;
}

export class NavigationPane extends VssComponent<INavigationPaneProps> {
    public render(): JSX.Element {
        const isTreeLoading = this.props.treeState.pagesFetchedStatus === PagesHierarchyFetchedStatus.None;

        return (
            <>
                <div
                    className={css("flex-column wiki-picker-ctr flex-noshrink", isCodeWiki(this.props.wikiInfo.wiki) ? "code-wiki" : "project-wiki")}
                >
                    <WrappedComponent
                        dependencies={["ms.vss-wiki-web.wiki-picker-content"]}
                        wrappedType={"wiki-picker"}
                        wikiInfo={this.props.wikiInfo}
                        showPublishCodeWikiAction={this.props.showPublishCodeWikiAction}
                        showCreateNewProjectWikiAction={this.props.showCreateNewProjectWikiAction}
                        loadingComponent={() => {
                            return (
                                <>
                                    <div className={"shimmer shimmer-line"} style={{ height: "32px", margin: "16px 12px 0px 12px" }} />
                                    {isCodeWiki(this.props.wikiInfo.wiki) && (
                                        <div className={"shimmer shimmer-line"} style={{ height: "32px", margin: "8px 12px 0px 12px" }} />
                                    )}
                                </>
                            );
                        }}
                    />
                </div>
                {isTreeLoading ? (
                    <TreeLoadingExperience />
                ) : (
                    <WikiPageTree
                        {...this.props}
                        itemProvider={this.props.treeState.treeItemProvider}
                        homePagePath={this.props.treeState.homePagePath}
                    />
                )}
            </>
        );
    }
}

const TreeLoadingExperience = (): JSX.Element => {
    const numOfRows = 7;
    let loadingRows: JSX.Element[] = [];
    for (let i = 0; i < numOfRows; i++) {
        loadingRows.push(
            <div className="flex-row" key={"loading-row-" + i}>
                <div className={"shimmer shimmer-circle-small  tree-shimmer-circle"} />
                <div className={"shimmer shimmer-line tree-shimmer-line"} style={{ width: _getVariableLength() }} />
            </div>
        );
    }
    return (
        <div>
            <div className={"shimmer shimmer-line tree-filter-shimmer"} />
            <div>{loadingRows}</div>
        </div>
    );
};

function _getVariableLength(): string {
    return Math.random() * 80 + 15 + "%";
}
